import { render } from "./PlansTable.vue?vue&type=template&id=52a6317e&scoped=true"
import script from "./PlansTable.vue?vue&type=script&lang=js"
export * from "./PlansTable.vue?vue&type=script&lang=js"

import "./PlansTable.vue?vue&type=style&index=0&id=52a6317e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52a6317e"]])

export default __exports__